<template>
  <section class="v3-user-board-wrap" aria-label="User Information">
    <Loader
      v-if="isLoading"
      :is-processing="true"
      data-testid="user-board-loader"
    />
    <div class="v3-user-board">
      <div class="user-data d-flex align-items-center">
        <div class="v3-avatar">
          <img
            :src="user.avatar ? user.avatar : '/img/avatars/user-avatar.jpeg'"
            :alt="`Avatar for ${user.name}`"
          />
        </div>
        <div class="v3-user-info ps-2 flex-1">
          <b class="font-size-14 text-wrap" data-test-id="sidebar-user-names">{{
            user.name
          }}</b>
          <p class="m-0 font-size-12">
            {{ userRole }}
          </p>
        </div>
      </div>
      <nav aria-label="School Selection" class="py-2 px-3">
        <SidebarSchools> </SidebarSchools>
      </nav>
      <div
        class="user-actions d-flex align-items-center p-0"
        role="group"
        aria-label="User Actions"
      >
        <div class="flex-1 text-center py-2 action-cell">
          <router-link
            data-test-id="sidebar-user-box"
            class="d-block"
            to="/user-settings"
            aria-label="User Settings"
          >
            <i class="ri-settings-3-line" aria-hidden="true"></i>
            <span class="sr-only">User Settings</span>
          </router-link>
        </div>
        <div
          class="flex-1 text-center d-flex justify-content-center py-2 action-cell action-sound"
        >
          <SoundBtn :user="user"></SoundBtn>
        </div>
        <button
          type="button"
          @click="logOut"
          data-test-id="sidebar-logout"
          class="flex-1 text-center py-2 v3-tooltip action-cell action-logout"
          aria-label="Log Out"
        >
          <span class="tooltiptext" aria-hidden="true">Log Out</span>
          <i class="ri-logout-circle-r-line" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"
import { useStore } from "vuex"
import SidebarSchools from "./SidebarSchools.vue"
import SoundBtn from "./SoundBtn.vue"
import Loader from "@/v3components/shared/Loader/Loader.vue"
export default {
  components: { SidebarSchools, SoundBtn, Loader },
  props: {
    user: Object
  },
  setup(props) {
    const store = useStore()
    const { t } = useI18n()
    const isLoading = ref(false)
    const logOut = () => {
      isLoading.value = true
      store.dispatch("authentication/logOut")
    }
    const userRole = computed(() => {
      const userRole = String(props?.user?.role?.name)
      return t(`common.${userRole.trim().toLowerCase()}`)
    })
    return {
      logOut,
      userRole,
      isLoading
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.user-actions .action-cell {
  border-radius: 4px;
}

.user-actions .action-sound:focus-within,
.user-actions .action-logout:focus,
.user-actions .action-logout:focus-visible {
  outline: 2px solid $outline-color !important;
  outline-offset: $outline-offset !important;
  border-radius: 4px;
}
</style>
